/**
 * Логика кабеля: марка по id и кабель по умолчанию.
 */
import { cableSection } from "./catalog";
import type { CableCatalogItem } from "./types";

export const cableItemById = (id: string): CableCatalogItem | null =>
	cableSection.items.find((item) => item.id === id) ?? null;

/** Кабель, которым прокладывают трассы, пока марка у кабеля на плане не выбирается. */
export const defaultCable = (): CableCatalogItem => cableSection.items[0];
